import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  params, string, shape, arrayOf, bool, extend, number
} from '@thd-nucleus/data-sources';
import {
  useProductDeprecated, useQuestionsAnswersDeprecated
} from '@thd-nucleus/data-sources/react/dataModel/migration';
import './product-details.style.scss';
import { dataModel } from '@thd-olt-component-react/ratings-and-reviews';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import Title from './components/ProductDetailsTitle.component';
import Badge from './components/ProductDetailsBadge.component';
import BrandCollection from './components/ProductDetailsBrandCollection.component';
import Ratings from './components/ProductDetailsRatings.component';
import { ProductDetailsContext } from './ProductDetailsContext';
import { ReviewsLoader } from './components/ReviewsLoader';
import { CustomerImageCarousel } from './components/CustomerImageCarousel.component';

const ProductDetails = ({ itemId, children }) => {

  const [questionsCount, setQuestionsCount] = useState('');

  const getQACount = () => {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      window.addEventListener('load', () => {
        setTimeout(() => {
          setQuestionsCount(document.getElementsByClassName('BVQANumber')[0]?.innerText);
        }, 1000);
      });
      window.removeEventListener('load', () => {});
    }
  };

  useEffect(() => {
    getQACount();
  }, [itemId]);

  const { channel } = useContext(ExperienceContext);
  const QandA = useQuestionsAnswersDeprecated({ itemId });
  const qaData = (QandA || {}).data;
  const { questionsAnswers } = qaData || {};
  const { TotalResults } = questionsAnswers || {};

  const { data, loading, error } = useProductDeprecated({
    domains: ['identifiers', 'media', 'reviews', 'taxonomy', 'info', 'details'],
    itemId,
  });

  if ((error && !data) || !data) {
    return null;
  }

  const { product } = data || {};

  const contextValue = {
    channel,
    itemId,
    product,
    questionsCount,
    TotalResults
  };

  return (
    <div className="product-details">
      <ProductDetailsContext.Provider value={contextValue}>
        {children}
      </ProductDetailsContext.Provider>
    </div>
  );
};

ProductDetails.propTypes = {
  children: PropTypes.node,
  itemId: PropTypes.string.isRequired,
};

ProductDetails.defaultProps = {
  children: null
};

ProductDetails.dataModel = extend(dataModel, {
  product: params({ itemId: string().isRequired() }).shape({
    itemId: string(),
    dataSources: string(),
    identifiers: shape({
      brandName: string(),
      canonicalUrl: string(),
      itemId: string(),
      productLabel: string(),
    }),
    info: shape({
      hidePrice: bool()
    }),
    details: shape({
      collection: shape({
        url: string()
      })
    }),
    media: shape({
      images: arrayOf(shape({
        url: string()
      }))
    }),
    reviews: shape({
      ratingsReviews: shape({
        averageRating: string(),
        totalReviews: string()
      })
    }),
    taxonomy: shape({
      brandLinkUrl: string()
    })
  }),
  questionsAnswers: params({ itemId: string().isRequired() }).shape({
    TotalResults: number()
  })
}, Badge, ReviewsLoader, CustomerImageCarousel);

ProductDetails.Badge = Badge;
ProductDetails.BrandCollection = BrandCollection;
ProductDetails.Ratings = Ratings;
ProductDetails.Title = Title;

export {
  Badge,
  BrandCollection,
  ProductDetails,
  Ratings,
  Title,
  ProductDetailsContext
};
